// Sub-neighborhoods within The Vineyards, used by the order form and feedback dropdowns.
const neighborhoods = [
  'Kenwood Townhomes',
  'Redwood Rookery',
  'The Ridge at Calistoga',
  'Napa',
  'Calistoga',
  'Salinas',
  'Solena I',
  'Solena II',
  'San Simeon',
  'St. Helena',
];

export default neighborhoods;
